import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col-xl-3 col-lg-3 col-md-4" }
const _hoisted_4 = { class: "col-xl-9 col-lg-9 col-md-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_Applications = _resolveComponent("Applications")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      pageTitle: "Applications",
      subTitle: "Apps"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Sidebar)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Applications)
      ])
    ])
  ]))
}